'use client';

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useRouter } from "next/navigation";
import { authPostRequest } from "@/lib/apiClient";
import Cookies from "js-cookie";

interface BlockedAlertProps {
  show: boolean;
  onClose: () => void;
}

export function BlockedAlert({ show, onClose }: BlockedAlertProps) {
  const router = useRouter();

  const handleClose = async () => {
    try {
      // Try to logout first
      await authPostRequest('auth/logout', {});
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      // Clear cookies and redirect to root
      Cookies.remove("token");
      Cookies.remove("reset");
      Cookies.remove("role");
      router.push('/');
      onClose();
    }
  };

  return (
    <Dialog open={show} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Access Blocked</DialogTitle>
          <DialogDescription>
            Your access has been blocked. Please contact your administrator.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
